import React from 'react';
import type {
  ISignatureInputRadioGroupProps,
  SignatureInputMode,
} from './types';
import { st, classes } from '../../style/TypeOrDrawSignatureInput.st.css';
import semanticClassNames from '../../../SignatureInput.semanticClassNames';
import { SignatureInputRadio } from './SignatureInputRadio';
import { DataHooks } from './constants';
import { formatClassNames } from '@wix/editor-elements-common-utils';

export const SignatureInputRadioGroup: React.FC<
  ISignatureInputRadioGroupProps
> = ({ id, disabled, selectedMode, onChange, translations, label }) => {
  const signatureModes = [
    {
      name: 'type' as SignatureInputMode,
      label: translations.radioTypeLabel || 'Type',
      dataHook: DataHooks.radioType,
    },
    {
      name: 'draw' as SignatureInputMode,
      label: translations.radioDrawLabel || 'Draw',
      dataHook: DataHooks.radioDraw,
    },
  ];

  const labelId = `label_${id}`;

  return (
    <fieldset
      className={classes.radioGroup}
      disabled={disabled}
      data-hook={DataHooks.radioGroup}
    >
      {label && (
        <legend
          id={labelId}
          className={st(
            classes.title,
            formatClassNames(semanticClassNames.label),
          )}
          data-hook={DataHooks.label}
        >
          {label}
        </legend>
      )}
      {signatureModes.map(mode => {
        return (
          <SignatureInputRadio
            id={id}
            key={mode.name}
            mode={mode.name}
            onChange={onChange}
            label={mode.label}
            checked={selectedMode === mode.name}
            dataHook={mode.dataHook}
          />
        );
      })}
    </fieldset>
  );
};
